module.exports = __webpack_public_path__ + "img/jazzb.f5ff65f6.jpg";